import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetStatus,
  UpdateStatus,
} from "../../../store/status-store/status-actions";
import StatusForms from "../../../components/Forms/StatusForms";
import { getTokenInfo } from "../../../utils/Guard";

const StatusEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.status.status);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (status.id===undefined || status.id === 0) {
      dispatch(GetStatus(param.statusId, userInfo.Email));
    }
  }, [param.statusId, userInfo.Email, dispatch, status]);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <StatusForms actionStatus={UpdateStatus} status={status} />
    </div>
    </>
  );
};
export default StatusEdit;
